/**
 * InvestorStats Component - Investor portal statistics
 */

import React from 'react'
import { Card } from '../ui'
import { Users, Eye, Clock, TrendingUp } from 'lucide-react'

const InvestorStats = ({
  stats = {},
  className = '',
  ...props
}) => {
  const defaultStats = {
    totalTokens: 0,
    activeTokens: 0,
    totalViews: 0,
    lastAccess: 'Never',
  }

  const data = { ...defaultStats, ...stats }

  const items = [
    {
      label: 'Total Tokens',
      value: data.totalTokens,
      icon: Users,
      color: 'bg-brand-soft text-brand',
    },
    {
      label: 'Active Tokens',
      value: data.activeTokens,
      icon: Clock,
      color: 'bg-success-soft text-success',
    },
    {
      label: 'Total Views',
      value: data.totalViews,
      icon: Eye,
      color: 'bg-info-soft text-info',
    },
    {
      label: 'Last Access',
      value: data.lastAccess,
      icon: TrendingUp,
      color: 'bg-gold-soft text-gold',
    },
  ]

  return (
    <Card className={`p-6 ${className}`} {...props}>
      <h3 className="text-sm font-semibold text-ink mb-4">Investor Portal Stats</h3>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        {items.map((item) => {
          const Icon = item.icon
          return (
            <div key={item.label} className="text-center">
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center mx-auto mb-2 ${item.color}`}>
                <Icon size={16} />
              </div>
              <p className="text-xl font-bold text-ink">{item.value}</p>
              <p className="text-[10px] text-muted mt-0.5">{item.label}</p>
            </div>
          )
        })}
      </div>
    </Card>
  )
}

InvestorStats.displayName = 'InvestorStats'

export default InvestorStats